import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Skeleton from '@mui/material/Skeleton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { useDashboardTheme, cardSx, panelHeaderSx, countBadgeSx, tableHeadRowSx, tableRowSx, scrollbarSx, fmt, fmtBtc, fmtTime } from '../utils';

const bidTypeColors = {
  normal: { label: 'Normal', color: 'info' },
  boss: { label: 'Boss', color: 'warning' },
  auto: { label: 'Auto', color: 'secondary' },
  auto_bid: { label: 'Auto', color: 'secondary' }
};

function RecentBidsFeed({ bids, loading }) {
  const t = useDashboardTheme();
  const bidData = bids?.data || [];

  return (
    <Card sx={cardSx}>
      <MDBox sx={panelHeaderSx(t)}>
        <MDTypography variant='h6' fontWeight='bold' sx={{ letterSpacing: '-0.01em', fontSize: '0.95rem', color: t.primaryText }}>
          Recent Bids
        </MDTypography>
        <MDBox sx={countBadgeSx(t)}>
          <MDTypography variant='caption' fontWeight='bold' sx={{ fontSize: '0.65rem', color: t.tableHeaderColor, letterSpacing: '0.04em' }}>
            {bids?.total ?? 0} total
          </MDTypography>
        </MDBox>
      </MDBox>
      {loading && bidData.length === 0 ? (
        <MDBox sx={{ p: { xs: 2, sm: 3 } }}>
          <Skeleton variant='rectangular' height={200} sx={{ borderRadius: '8px' }} />
        </MDBox>
      ) : bidData.length === 0 ? (
        <MDBox display='flex' flexDirection='column' alignItems='center' justifyContent='center' py={4} gap={1}>
          <MDTypography variant='body2' color='text' sx={{ opacity: 0.45 }}>No bids yet</MDTypography>
        </MDBox>
      ) : (
        <TableContainer sx={{ ...scrollbarSx(t), maxHeight: 340 }}>
          <Table size='small' stickyHeader>
            <TableHead>
              <TableRow sx={tableHeadRowSx(t)}>
                <TableCell>Time</TableCell>
                <TableCell>Player</TableCell>
                <TableCell>Type</TableCell>
                <TableCell align='right'>USD</TableCell>
                <TableCell align='right'>BTC</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bidData.slice(0, 50).map((bid, index) => {
                const typeInfo = bidTypeColors[bid.bidType] || { label: bid.bidType, color: 'default' };
                return (
                  <TableRow key={bid.id} sx={tableRowSx(t, { index })}>
                    <TableCell>
                      <MDTypography variant='caption' sx={{ fontSize: '0.73rem', color: t.secondaryText }}>{fmtTime(bid.createdAt)}</MDTypography>
                    </TableCell>
                    <TableCell>
                      <MDTypography variant='caption' fontWeight='medium' sx={{ fontSize: '0.78rem', color: t.primaryText }}>{bid.nickname || bid.username}</MDTypography>
                    </TableCell>
                    <TableCell>
                      <Chip label={typeInfo.label} color={typeInfo.color} size='small' sx={{ height: 18, fontSize: '0.63rem' }} />
                    </TableCell>
                    <TableCell align='right'>
                      <MDTypography variant='caption' fontWeight='bold' sx={{ fontSize: '0.75rem', color: t.primaryText }}>${fmt(bid.bidAmountUsd)}</MDTypography>
                    </TableCell>
                    <TableCell align='right'>
                      <MDTypography variant='caption' sx={{ fontSize: '0.73rem', color: t.secondaryText }}>{fmtBtc(bid.bidAmountBtc)}</MDTypography>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Card>
  );
}

export default RecentBidsFeed;
